import type { WalkthroughStep } from "../types";

/**
 * The JOAAT Hash Generator's tour, which only ever runs because somebody asked.
 *
 * This tool has no sample pack: it opens with `weapon_pistol` already typed, so
 * there is nothing to demo and no `welcome` step. The one way in is the
 * permanent "Show me how this works" control beside the input (`ShowTourButton`),
 * and the island mounts `ToolWalkthrough` in manual mode, so nothing here is
 * ever thrown over a name somebody is in the middle of hashing.
 *
 * The results block only exists while the input is non-empty. A step whose
 * anchor is missing degrades to a centred tooltip, so the body reads as an
 * explanation of that part of the page rather than "look at this row".
 *
 * These steps RESTATE what the page already says; the "(lowercased)" line and
 * the empty-state hint stay in the interface.
 */
export const steps: WalkthroughStep[] = [
  {
    id: "input",
    title: "Type a name",
    body: "Any model, weapon, ped or audio name. It is lowercased before hashing, so `Police3` and `police3` give the same result. Nothing leaves your browser.",
    selector: "[data-walkthrough='jh-input']",
    placement: "bottom",
  },
  {
    id: "examples",
    title: "Or try a known one",
    body: "These fill the box with a real in-game name, handy for checking a hash you already have against a name you expect.",
    selector: "[data-walkthrough='jh-examples']",
    placement: "bottom",
  },
  {
    id: "results",
    title: "Three forms of the same hash",
    body: "Unsigned, signed and hex are the same 32-bit number written three ways. Use whichever your script, meta file or database dump expects, and copy it with the button on the row.",
    selector: "[data-walkthrough='jh-results']",
    placement: "top",
  },
];

export const finishLabel = "Start hashing";
